export default __webpack_public_path__ + "static/media/oratoria.4698d8b4.jpeg";